import React from "react";

export const ErrorPage = () => {
    return <>
        <h1>An error has occured.</h1>
    </>
}